import {toast} from "react-toastify";
import {
  LOAD_SETTINGS,
  SET_SETTINGS,
  EDIT_CALENDER_SETTINGS,
  EDIT_GENERAL_SETTINGS,
  EDIT_NOTIFICATION_SETTINGS,
  EDIT_INVOICES_SETTINGS,
  } from './types';
import {actionForState} from "../../common/functions/utils";
import { colors } from "@material-ui/core";

toast.configure();
  
  const INITIAL_STATE = {
    currencyArray: ['INR', 'EUR', 'GDP', 'USD', 'CAD'],
    dateFormatArray: [{
      id:'M1',
      val:'yyyy/MM/dd',
      display:'YYYY/MM/DD'
    },
      {
        id:'M2',
        val:'yy/MM/dd',
        display:'YY/MM/DD'
      },
      {
        id:'M3',
        val: 'yyyy-MM-dd',
        display: 'YYYY-MM-DD'
      },
      {
        id:'M4',
        val: 'yy-MM-dd',
        display: 'YY-MM-DD'
      },
      {
        id:'M5',
        val: 'MM/dd/yyyy',
        display: 'MM/DD/YYYY'
      },
      {
        id:'M6',
        val: 'MM/dd/yy',
        display: 'MM/DD/YY'
      },
      {
        id:'M7',
        val: 'MM-dd-yyyy',
        display: 'MM-DD-YYYY'
      },
      {
        id:'M8',
        val: 'MM-dd-yy',
        display: 'MM-DD-YY'
      },
      {
        id:'M9',
        val: 'MMM dd, yyyy',
        display: 'MMM DD, YYYY'
      },
      {
        id:'M10',
        val: `MMM dd yy`,
        display: `MMM DD 'YY`
      },
      {
        id:'M11',
        val: `dd/MM/yyyy`,
        display: `DD/MM/YYYY`
      },
  ],
    numberFormatArray: [
      {
        id:'M1',
        val:'1,000.00',
      },
      {
        id:'M2',
        val:'1\'000.00',
      },
      {
        id:'M3',
        val:'1.000,00'
      }
    ],
    setting: {
      currency : {value:"USD",label:"USD"},
      timeDisplay : 'H',
      dateDisplay: 'M11',
      numberDisplay: '1,000.00',
      isFutureBooking:true
    },
    action:{
      loading:false,
      success:undefined
    },
    actionForSettings:{
      loading: false,
      success: false,
      error:false
    },
    actionForSettingsEdit:{
      loading: false,
      success: false,
      error:false
    },
    actionForEditGeneralSettings: {
      loading: false,
      success: false,
      error: false,
    },
    actionForEditCalenderSettings: {
      loading: false,
      success: false,
      error: false,
    },
    actionForEditNotificationSettings: {
      loading: false,
      success: false,
      error: false,
    },
    actionForEditInvoicesSettings: {
      loading: false,
      success: false,
      error: false,
    },
  };
  
  export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
      case SET_SETTINGS.pending:
        return {
          ...state,
          actionForSettingsEdit: actionForState(state.action, 'pending'),
        }
      case SET_SETTINGS.success:
        toast.success("Settings have been updated successfuly!")
        if(state.setting.currency.label!==action.payload.data.customer.currency){
          toast.warn("The default currency has been changed. Please note this will not impact currency in existing rentals and existing bookings. To change the currency of existing rentals, please go to Rentals and edit the rental whose currency you would like to change")
        }
        if(state.setting.emailId !== action.payload.data.customer.emailId){
          toast.warn('Email change: please check your email to confirm the change.')
        }
        return {
          ...state,
          setting: {
            ...action.payload.data.customer,
            currency: {
              value: action.payload.data.customer.currency,
              label: action.payload.data.customer.currency
            },
            colors: action.payload.data.colors
          },
          actionForSettingsEdit: actionForState(state.action, 'success')
        }
      case SET_SETTINGS.error:
        toast.error(action.payload.message)
        return {
          ...state,
          actionForSettingsEdit: actionForState(state.action, 'error',action.payload.message),
        }
      case LOAD_SETTINGS.pending:
        return{
          ...state,
          actionForSettings: actionForState(state.action,'pending')
        }
      case LOAD_SETTINGS.success:
        return{
          ...state,
          setting: {
            ...action.payload.data.customer,
            currency: {
              value: action.payload.data.customer.currency,
              label: action.payload.data.customer.currency
            },
            colors: action.payload.data.colors
          },
          actionForSettings: actionForState(state.action,'success')
        }
      case LOAD_SETTINGS.error:
        toast.error(action.payload.message);
        return{
          ...state,
          actionForSettings: actionForState(state.action,'error',action.payload.message)
        }
        case EDIT_GENERAL_SETTINGS.pending:
          return {
            ...state,
            actionForEditGeneralSettings: actionForState(state.action, 'pending')
          };
        case EDIT_GENERAL_SETTINGS.success:
          toast.success("General settings updated successfully!");
          return {
            ...state,
            setting: {
              ...action.payload.data,
              currency: {
                value: action.payload.data.currency,
                label: action.payload.data.currency
              },
              colors: state.setting.colors
            },
            actionForEditGeneralSettings: actionForState(state.action, 'success')
          };
        case EDIT_GENERAL_SETTINGS.error:
          toast.error(action.payload.message);
          return {
            ...state,
            actionForEditGeneralSettings: actionForState(state.action, 'error', action.payload.message)
          };
    
        case EDIT_CALENDER_SETTINGS.pending:
          return {
            ...state,
            actionForEditCalenderSettings: actionForState(state.action, 'pending')
          };
        case EDIT_CALENDER_SETTINGS.success:
          toast.success("Calendar settings updated successfully!");
          return {
            ...state,
            setting: {
              ...action.payload.data.customer,
              currency: {
                value: action.payload.data.customer.currency,
                label: action.payload.data.customer.currency
              },
              colors: action.payload.data.colors
            },
            actionForEditCalenderSettings: actionForState(state.action, 'success')
          };
        case EDIT_CALENDER_SETTINGS.error:
          toast.error(action.payload.message);
          return {
            ...state,
            actionForEditCalenderSettings: actionForState(state.action, 'error', action.payload.message)
          };
    
        case EDIT_NOTIFICATION_SETTINGS.pending:
          return {
            ...state,
            actionForEditNotificationSettings: actionForState(state.action, 'pending')
          };
        case EDIT_NOTIFICATION_SETTINGS.success:
          toast.success("Notification settings updated successfully!");
          return {
            ...state,
            setting: {
              ...action.payload.data,
              currency: {
                value: action.payload.data.currency,
                label: action.payload.data.currency
              },
              colors: state.setting.colors
            },
            actionForEditNotificationSettings: actionForState(state.action, 'success')
          };
        case EDIT_NOTIFICATION_SETTINGS.error:
          toast.error(action.payload.message);
          return {
            ...state,
            actionForEditNotificationSettings: actionForState(state.action, 'error', action.payload.message)
          };
    
        case EDIT_INVOICES_SETTINGS.pending:
          return {
            ...state,
            actionForEditInvoicesSettings: actionForState(state.action, 'pending')
          };
        case EDIT_INVOICES_SETTINGS.success:
          toast.success("Invoice settings updated successfully!");
          return {
            ...state,
            setting: {
              ...action.payload.data,
              currency: {
                value: action.payload.data.currency,
                label: action.payload.data.currency
              },
              colors: state.setting.colors
            },
            actionForEditInvoicesSettings: actionForState(state.action, 'success')
          };
        case EDIT_INVOICES_SETTINGS.error:
          toast.error(action.payload.message);
          return {
            ...state,
            actionForEditInvoicesSettings: actionForState(state.action, 'error', action.payload.message)
          };
      default:
        return state;
    }
  }
  